module.exports = __webpack_public_path__ + "img/accept icon.a23a75e6.svg";